<key-leaflet-map class="h-100" key-content-container #map [controls]="mapControls" (mapReady)="onMapReady.emit()"></key-leaflet-map>
